import { useLocation, useNavigate } from "react-router-dom";
import { useState, useEffect, useRef } from "react";
import "./navbar.css";
import logo from "../Assets/Images/Logo.png";
import user from "../Assets/Images/user.webp";
import api from "../api";
import { Client } from "@stomp/stompjs";
import SockJS from "sockjs-client";

const roleBasedMenus = {
  ADMIN: {
    navItems: [
      {
        name: "Anagrafiche Docenti",
        icon: "fa-solid fa-chalkboard-user",
        link: "/docenti",
        title: "Docenti",
        activeMatch: ["/docenti", "/docenti/:id"],
      },
      {
        name: "Utenti",
        icon: "fa-solid fa-headset",
        link: "/utenti",
        title: "Utenti",
        activeMatch: ["/utenti", "/utenti/:id", "/aggiungi-utente"],
      },
      {
        name: "Ricerche",
        icon: "bx bxs-file-find",
        link: "/ricerche",
        title: "Ricerche",
        activeMatch: ["/ricerche", "/aggiungi-ricerca", "/ricerca/:id"],
      },
      {
        name: "Sedi",
        icon: "fa-solid fa-map-location",
        link: "/sedi",
        title: "Sedi",
        activeMatch: ["/sedi", "/aggiungi-sede", "/sede/:id"],
      },
      {
        name: "Tipologia Titoli",
        icon: "fas fa-tags",
        link: "/tipologia-titolo",
        title: "Tipologia Titoli",
        activeMatch: [
          "/tipologia-titolo",
          "/aggiungi-tipologia-titolo",
          "/tipologia-titolo/:id",
        ],
      },
      {
        name: "Candidature",
        icon: "fa-solid fa-clipboard-check",
        link: "/candidature",
        title: "Candidature",
        activeMatch: ["/candidature"],
      },
      {
        name: "Mansioni",
        icon: "fa-solid fa-briefcase",
        link: "/mansioni",
        title: "Mansioni",
        activeMatch: ["/mansioni", "/aggiungi-mansione", "/mansioni/:id"],
      },
      {
        name: "Associazioni",
        icon: "fa-solid fa-user-plus",
        link: "/associazioni",
        title: "Associazioni",
        activeMatch: [
          "/associazioni",
          "/aggiungi-associazione",
          "/associazione/:id",
        ],
      },
      {
        name: "Accordo Quadro",
        icon: "fa-solid fa-list-check",
        link: "/accordo-quadro",
        title: "Accordo Quadro",
        activeMatch: [
          "/accordo-quadro",
          "/aggiungi-accordo",
          "/accordo-quadro/:id",
        ],
      },
      {
        name: "Interviste",
        icon: "fa-solid fa-clipboard-question",
        link: "/interviste",
        title: "Interviste",
        activeMatch: ["/interviste", "/aggiungi-intervista", "/intervista/:id"],
      },
      {
        name: "Feedback",
        icon: "fa-solid fa-comments",
        link: "/feedback",
        title: "Feedback",
        activeMatch: ["/feedback", "/aggiungi-feedback", "/feedback/:id"],
      },
      {
        name: "Follow up",
        icon: "fa-solid fa-user-plus",
        link: "/follow-up",
        title: "Follow up",
        activeMatch: ["/follow-up", "/aggiungi-follow-up", "/follow-up/:id"],
      },
      {
        name: "Simulazioni",
        icon: "fa-solid fa-file-circle-question",
        link: "/simulazioni",
        title: "Simulazioni",
        activeMatch: [
          "/simulazioni",
          "/aggiungi-simulazione",
          "/simulazione/:id",
        ],
      },
      {
        name: "Moduli Protocollati",
        icon: "bx bx-spreadsheet",
        link: "/moduli-protocollati",
        title: "Moduli Protocollati",
        activeMatch: [
          "/moduli-protocollati",
          "/moduli-protocollati/:id",
          "/aggiungi-moduli-protocollati",
        ],
      },
    ],
  },

  OPERATOR: {
    navItems: [
      {
        name: "Docenti",
        icon: "fa-solid fa-chalkboard-user",
        link: "/docenti/disponibile",
        title: "Docenti",
        activeMatch: ["/docenti/disponibile", "/docente/disponibile/:id"],
      },
      {
        name: "Ricerche",
        icon: "bx bxs-file-find",
        link: "/ricerche/me",
        title: "Ricerche",
        activeMatch: ["/ricerche/me", "/aggiungi-ricerca", "/ricerca/:id"],
      },
      {
        name: "Sedi",
        icon: "fa-solid fa-location-dot",
        link: "/sedi/me",
        title: "Sedi",
        activeMatch: ["/sedi/me", "/aggiungi-sede", "/sedi/:id"],
      },
      {
        name: "Candidature",
        icon: "fa-solid fa-clipboard-check",
        link: "/candidature",
        title: "Candidature",
        activeMatch: ["/candidature"],
      },
      {
        name: "Feedback",
        icon: "fa-solid fa-comments",
        link: "/aggiungi-feedback",
        title: "Feedback",
        activeMatch: ["/aggiungi-feedback", "/feedback/:id"],
      },
    ],
  },

  TRAINER: {
    navItems: [
      {
        name: "Posizioni Aperte",
        icon: "fa-solid fa-list-check",
        link: "/ricerche/posizioni-aperte",
        title: "Posizioni Aperte",
        activeMatch: ["/ricerche/posizioni-aperte"],
      },
      {
        name: "Mie Candidature",
        icon: "fa-solid fa-briefcase",
        link: "/candidature/me",
        title: "Mie Candidature",
        activeMatch: ["/candidature/me"],
      },

      {
        name: "Titoli di studi",
        icon: "fa-solid fa-certificate",
        link: "/titoli-studi",
        title: "Titoli di Studi",
        activeMatch: [
          "/titoli-studi",
          "/aggiungi-titoli-studi",
          "/titoli-studi/:id",
        ],
      },
      {
        name: "Moduli Protocollati",
        icon: "bx bx-spreadsheet",
        link: "/moduli-protocollati",
        title: "Moduli Protocollati",
        activeMatch: [
          "/moduli-protocollati",
          "/moduli-protocollati/:id",
          "/aggiungi-moduli-protocollati",
        ],
      },
      {
        name: "Curriculum",
        icon: "bx bx-file",
        link: "/curriculum",
        title: "Curriculum",
        activeMatch: ["/curriculum"],
      },
      {
        name: "Esperienze lavorative",
        icon: "fa-solid fa-briefcase",
        link: "/esperienze-lavorative",
        title: "Esperienze lavorative",
        activeMatch: [
          "/esperienze-lavorative",
          "/aggiungi-esperienze-lavorative",
          "/esperienze-lavorative/:id",
        ],
      },
    ],
  },
};

const Navbar = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [openMenu, setOpenMenu] = useState(false);
  const [openDropdownMenu, setOpenDropdownMenu] = useState(false);
  const menuRef = useRef(null);
  const profileRef = useRef(null);
  const userRole = localStorage.getItem("userRole");
  const navItems = roleBasedMenus[userRole]?.navItems || [];
  const [isShortScreen, setIsShortScreen] = useState(false);
  const [notifications, setNotifications] = useState([]);
  const [showNotifications, setShowNotifications] = useState(false);
  const hasFetchedNotifications = useRef(false);
  const notificationRef = useRef(null);

  const stompClient = useRef(null);

  useEffect(() => {
    fetchNotifications();
  }, []);

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token) return;

    // Disable websocket when running locally
    const isLocal = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1' || process.env.NODE_ENV === 'development';
    if (isLocal) return;

    stompClient.current = new Client({
      webSocketFactory: () => new SockJS("/ws"),
      connectHeaders: {
        Authorization: `Bearer ${token}`,
      },
      reconnectDelay: 5000,
      debug: (str) => console.log("[STOMP]", str),
    });

    stompClient.current.onConnect = () => {
      stompClient.current.subscribe("/user/queue/notifications", (msg) => {
        try {
          if (msg.body) {
            const notification = JSON.parse(msg.body);
            setNotifications((prev) => [notification, ...prev]);
          }
        } catch (e) {
          console.error("Failed to parse notification", e);
        }
      });
    };

    stompClient.current.activate();

    return () => {
      stompClient.current.deactivate();
    };
  }, []);

  // useEffect(() => {
  //   if (!hasFetchedNotifications.current) {
  //     fetchNotifications();
  //     hasFetchedNotifications.current = true;
  //   }
  // }, []);

  const fetchNotifications = async () => {
    try {
      const res = await api.get("/notifications");

      if (res.status === 200) {
        setNotifications(res.data);
      }
    } catch (err) {
      console.error("Error fetching notifications", err);
    }
  };

  const markAsRead = async (notificationId) => {
    try {
      const res = await api.put(`/notifications/${notificationId}/read`);

      if (res.status === 200) {
        setNotifications((prev) => prev.filter((n) => n.id !== notificationId));
      }
    } catch (err) {
      console.error("Error marking notification as read", err);
    }
  };

  // const handleNotificationClick = () => {
  //   if (!showNotifications) fetchNotifications();
  //   setShowNotifications(!showNotifications);
  // };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        notificationRef.current &&
        !notificationRef.current.contains(event.target)
      ) {
        setShowNotifications(false);
      }
    };

    if (showNotifications) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showNotifications]);

  useEffect(() => {
    const checkHeight = () => {
      setIsShortScreen(window.innerHeight < 690);
    };
    checkHeight();
    window.addEventListener("resize", checkHeight);
    return () => window.removeEventListener("resize", checkHeight);
  }, []);

  const redirect = (path) => {
    navigate(path);
    setOpenMenu(false);
  };

  const toggleDropdown = () => {
    setOpenDropdownMenu((prev) => !prev);
  };

  const handleLogOut = async () => {
    try {
      const response = await api.post("/auth/logout");
      localStorage.clear();
      navigate("/login");
    } catch (error) {
      console.log(error);
    }
  };

  const handleEditUser = () => {
    navigate("/profilo");
    setOpenDropdownMenu(false);
  };

  const handleClickOutside = (event) => {
    if (
      menuRef.current &&
      !menuRef.current.contains(event.target) &&
      profileRef.current &&
      !profileRef.current.contains(event.target)
    ) {
      setOpenMenu(false);
      setOpenDropdownMenu(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div className="manage-navbar">
      <div className="logo-img">
        <img src={logo} alt="logo" />
      </div>

      <div className="nav-menus">
        <div className="notification-wrapper">
          <button
            onClick={() => setShowNotifications((prev) => !prev)}
            title="Notifiche"
            className="notification-icon"
          >
            <i className="fa-solid fa-bell" />
            {notifications && notifications.length > 0 && (
              <div className="navbar-badge">{notifications.length}</div>
            )}
          </button>
          {showNotifications && (
            <div ref={notificationRef} className="notification-menu">
              <div className="notification-header">Notifiche</div>

              {notifications.length > 0 && (
                <>
                  {notifications.map((n) => (
                    <div key={n.id} className="notification-item unread">
                      <div className="notification-data">
                        <div className="notification-item-title">
                          {n.message || "Hai una nuova notifica"}
                        </div>
                        <div className="notification-button">
                          <button
                            className="mark-read-btn"
                            onClick={() => markAsRead(n.id)}
                          >
                            <i className="fa-solid fa-envelope-open-text"></i>
                          </button>
                        </div>
                      </div>
                      <div className="notification-time">
                        {new Date(n.timestamp).toLocaleString()}
                      </div>
                    </div>
                  ))}
                </>
              )}

              {notifications?.length === 0 && (
                <div className="no-notifications">Nessuna notifica</div>
              )}
            </div>
          )}
        </div>

        <div className="user-profile" ref={profileRef}>
          <button onClick={toggleDropdown}>
            <i className="fa-solid fa-user user-icon"></i>
          </button>
          {openDropdownMenu && (
            <div className="profile-menu">
              <ul>
                <li onClick={handleEditUser}>
                  <i className="fa-solid fa-user"></i> Profile
                </li>
                <li onClick={handleLogOut}>
                  <i className="fa-solid fa-right-from-bracket"></i> Log out
                </li>
              </ul>
            </div>
          )}
        </div>

        <div
          className={`navbar-menu ${openMenu ? "expanded" : "collapsed"}`}
          ref={menuRef}
        >
          <div className="burger-menu" onClick={() => setOpenMenu(!openMenu)}>
            {openMenu ? (
              <i className="fa-solid fa-x"></i>
            ) : (
              <i className="fa-solid fa-bars"></i>
            )}
          </div>

          <div
            className={`menu-tabs ${openMenu ? "expanded" : "collapsed"} ${
              isShortScreen ? "scrollable-menu" : ""
            }`}
          >
            {navItems.map((item, index) => {
              const isActive = item.activeMatch?.some((route) =>
                location.pathname.startsWith(route.replace(/:\w+/g, ""))
              );

              return (
                <div
                  key={index}
                  className={`menu-tab ${isActive ? "active" : ""}`}
                  onClick={() => redirect(item.link)}
                  title={item.title}
                >
                  <i className={item.icon}></i>
                  <span>{item.title}</span>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Navbar;
